export const Faqs = [
  {
    pergunta: 'Como funciona a Energia Solar?',
    resposta: `As placas solares captam os raios de sol e os transformam em energia elétrica por meio de um equipamento chamado inversor. A energia gerada é enviada para a rede elétrica e você passa a ter créditos de energia em sua conta. Caso gere mais do que consumiu, irá acumular créditos, caso consuma mais energia, irá receber uma conta de luz com a diferença entre o que foi gerado e consumido.`,
    startOpen: true,
  },
  {
    pergunta: 'Por que adquirir um sistema fotovoltaico?',
    resposta: `A energia solar é uma fonte de energia limpa e renovável, que traz um impacto positivo para o planeta e para sua comunidade. Além disso, valoriza o imóvel em que foi instalada e a melhor parte é que pode não custar nada mais do que o seu orçamento permite. É possível substituir a sua conta de luz pela parcela do painel solar, sendo um investimento de longo prazo, com mais de 20 anos de garantia dos painéis.`,
  },
  {
    pergunta: 'Quais os benefícios de adquirir um sistema fotovoltaico?',
    resposta: `Você irá gerar energia com um baixo impacto para o meio ambiente, além disso você troca o gasto em energia por um investimento em seu imóvel e o valoriza.`,
  },
  {
    pergunta: 'Onde consigo instalar o meu sistema fotovoltaico?',
    resposta: `É possível instalar o sistema fotovoltaico em telhados com incidência solar, além disso, a depender do caso, a instalação também pode ser feita no solo.`,
  },
  {
    pergunta: 'Como funciona o crédito na conta de luz?',
    resposta: `Toda a energia que gerada pela sua placa solar será enviada de volta para rede, gerando assim, créditos de consumo em sua conta de luz válidos por até 60 meses. Caso a geração de energia seja maior do que o consumido, mensalmente você pagará apenas a taxa de disponibilidade da concessionaria. Caso o consumo seja maior do que a geração, será paga a diferença entre eles para a empresa de energia.`,
  },
  {
    pergunta: 'Se eu instalar um sistema fotovoltaico, irei pagar conta de luz?',
    resposta: `Caso você gere mais energia do que consome, você pagará mensalmente a tarifa básica da concessionária de energia elétrica da sua região. Caso consuma mais energia do que gerou, terá de pagar o excedente. Porém, ao realizar o seu projeto, será considerado o seu consumo médio de energia e é provável que você só consuma mais energia do que o gerado caso haja algum consumo fora dos padrões (exemplo: instalação de um novo ar-condicionado, aquecedor na piscina).`,
  },
  {
    pergunta: 'O meu painel solar gera energia quando o sol não está brilhando?',
    resposta: `Sim, mesmo com um dia nublado ou chuvoso o seu painel solar irá gerar energia. Porém, será em menor quantidade do que o gerado em um dia de sol.`,
  },
  {
    pergunta: 'Em quanto tempo terei que trocar os meus painéis solares (placas)?',
    resposta: `Os painéis solares possuem garantia de eficiência de mais de 20 anos e nesse período poderá ser necessário fazer a manutenção do seu sistema. Passado este tempo, é preciso verificar a geração de energia e entender se é preciso, ou não, trocar os painéis.`,
  },
  {
    pergunta: 'Como saber se posso instalar um sistema fotovoltaico no meu telhado?',
    resposta: `Caso você queira instalar em uma casa, por meio da simulação e da visita técnica realizada pelo parceiro, será possível determinar a viabilidade e o projeto ideal para atender às suas necessidades. Caso seja em um prédio, é preciso que seja definido em assembleia do condomínio a possibilidade de instalação.`,
  },
  {
    pergunta: 'Consigo instalar os painéis no chão ou outro lugar fora do telhado?',
    resposta: `Sim. Neste caso, é necessário que a simulação seja realizada para que ocorra um contato posterior com os técnicos do parceiro, permitindo assim a validação do projeto apresentado.`,
  },
  {
    pergunta: 'Preciso colocar baterias no meu sistema fotovoltaico?',
    resposta: `Caso o projeto seja feito em um local remoto, sem acesso à energia elétrica, é preciso que tenha baterias no seu sistema fotovoltaico. Neste caso o parceiro desenvolve um projeto personalizado. Porém, caso tenha acesso a energia elétrica, não é preciso o uso das baterias.`,
  },
  {
    pergunta: 'Como é feita a manutenção do meu painel solar?',
    resposta: `O sistema não exige muita manutenção, apenas a limpeza dos módulos uma vez por ano. Em dias de chuva, a própria água realiza a limpeza e manutenção dos módulos.`,
  },
  {
    pergunta: 'Qual o processo desde a contratação até a primeira geração de energia?',
    resposta: `O processo começa com a simulação do projeto com o Santander, considerando o consumo de energia e as características do imóvel. Em seguida ocorre a formalização do contrato, conduzida pelo parceiro responsável pelo projeto, que pode validar informações e documentos necessários.<br>
              Depois disso, o parceiro desenvolve o projeto e realiza a instalação do sistema de energia solar. Após a instalação e a aprovação da concessionária de energia, o sistema é liberado e a geração de energia começa normalmente.`,
  },
  {
    pergunta: 'Caso eu me mude e não queira instalar novamente, o que acontece com meus créditos?',
    resposta: `Os créditos de energia são por CPF/CNPJ, ou seja, poderá gerar em sua casa energia para seu escritório ou casa de veraneio, ou até mesmo para uma segunda casa que você não reside. Isso é válido para locais com a mesma rede elétrica conectados com o mesmo CPF/CNPJ.`,
  },
  {
    pergunta: 'Posso instalar no meu apartamento?',
    resposta: `Caso você more na cobertura e tenha um telhado próprio, poderá instalar em seu apartamento. Caso não, deverá solicitar autorização em uma assembleia do condomínio.`,
  },
  {
    pergunta: 'Por que adquirir meu sistema fotovoltaico com o Santander?',
    resposta: `Com o Santander você terá acesso as melhoras taxas do mercado, com até 120 dias de carência para pagamento da primeira parcela. Além de ter o projeto realizado com nossos parceiros, com as melhores placas do mercado.`,
  },
  {
    pergunta: 'Qual o prazo máximo para o parcelamento?',
    resposta: `O prazo máximo é de até 96 parcelas.`,
  },
  {
    pergunta: 'Em quanto tempo pagarei a primeira parcela?',
    resposta: `Em até 120 dias`,
  },
  {
    pergunta: 'Quais as formas de pagamento do meu sistema fotovoltaico adquirido com o Santander?',
    resposta: `Caso seja correntista Santander, o financiamento poderá pagar por boleto ou débito em conta corrente. Caso não seja, o pagamento do financiamento é por meio de boletos. Outras formas de pagamento também podem ser sugeridas, e o financiamento é sujeito a avaliação de crédito.`,
  },
  {
    pergunta:
      'Para adquirir o sistema fotovoltaico é preciso ter conta corrente no banco Santander?',
    resposta: `Não. É possível fazer o projeto com os nossos parceiros sem ser correntista.`,
  },
  {
    pergunta: 'A companhia elétrica permite que eu gere energia?',
    resposta: `Sim, é permitido desde 2012 com a Resolução Normativa da ANEEL 482/2012.`,
  },
  {
    pergunta: 'Como sei quantas placas preciso instalar no meu sistema?',
    resposta: `Esta conta é feita baseada no consumo médio mensal de energia, além do fator gerador de sua cidade. Além disso, aspectos físicos são levados em consideração, como a inclinação, orientação e o sombreamento do telhado. Por meio da tecnologia utilizada pelo parceiro, todos esses fatores são processados para a apresentação do orçamento ideal.`,
  },
  {
    pergunta: 'O que é o inversor? Para que ele serve?',
    resposta: `O inversor é o equipamento responsável por converter a energia gerada pelos painéis em um padrão compatível com a residência e com a rede da concessionária.`,
  },
  {
    pergunta: 'O que é kWh? Qual a diferença entre kWp',
    resposta: `O kWh é a unidade de medida que aparece na sua conta de luz. Ela significa a quantidade de energia consumida ou gerada - no caso de sistemas solares. Já o kWp é a unidade de medida que você utilizará para comprar um sistema fotovoltaico. Significa o total da potência instalada dos módulos - ou seja, se você tem 10 módulos de 335Wp, você terá um sistema de 3.350Wp ou 3,35kWp. Atenção! Não necessariamente a potência instalada será igual a potência gerada devido à fatores climáticos ou sombreamento.`,
  },
  {
    pergunta: 'Qual a diferença entre um sistema On-Grid e Off-grid?',
    resposta: `On-grid é o sistema conectado com a rede da concessionária de energia, nesse modelo é necessário pedir autorização para concessionária para realizar a conexão. Já o sistema Off-Grid é um sistema remoto que conta com um banco de baterias, nele não há conexão com a rede da concessionária. Esse tipo de projeto costuma ser mais caro e recomendado para lugares com difícil acesso à rede.`,
  },
  {
    pergunta: 'Posso vender a energia que eu gero?',
    resposta: `Não. No Brasil é proibida a venda de energia, mas você pode usar os créditos em outra(s) residência(s), contanto, que estejam sobre a mesma concessionária de energia e tenham o mesmo titular de conta (CPF ou CNPJ).`,
  },
  {
    pergunta: 'Meu sistema vai funcionar a noite?',
    resposta: `Você terá energia elétrica para consumir em qualquer situação de tempo e clima: em dias de sol, chuva, a noite ou de dia. Agora, em termos de desligamento, os sistemas on-grid desligam a noite, pois eles só ficam ligados enquanto há sol. Os sistemas off-grid ficam ligados à noite, através do banco de baterias que foi carregado durante o dia…`,
  },
  {
    pergunta: 'Se acabar a luz, meu sistema (on-grid) desliga?',
    resposta: `Sim, porém, por medidas de segurança, quando a energia acaba o sistema desliga automaticamente. Já os sistemas off-grid não são afetados por faltas de luz na rede.`,
  },
  {
    pergunta: 'Meu sistema vai gerar energia em dias nublados ou chuvosos?',
    resposta: `Sim, mas em menor quantidade comparado a um dia de sol.`,
  },
  {
    pergunta: 'Quanto tempo dura a instalação?',
    resposta: `A instalação varia de acordo com o tamanho do sistema e complexidade do local de instalação, mas em média varia entre 2 e 15 dias. Casos de grandes projetos e alta complexidade, podem levar mais de 15 dias.`,
  },
  {
    pergunta: 'Os módulos são instalados na minha telha?',
    resposta: `Não, é instalada uma estrutura específica sobre o telhado, onde os módulos são fixados pelo parceiro.`,
  },
  {
    pergunta: 'Como é feita a infraestrutura elétrica?',
    resposta: `A infraestrutura elétrica é aparente. É possível fazê-la embutida, porém é preciso contratar uma mão de obra especializada em reforma ou construção civil.`,
  },
  {
    pergunta: 'A instalação pode ocorrer em dias de chuva?',
    resposta: `Não. Por questões de segurança e padrões de qualidade, a instalação só pode acontecer sem chuva.`,
  },
  {
    pergunta: 'Os equipamentos têm garantia?',
    resposta: `Sim. Os prazos de garantia para os módulos e inversores são determinados conforme as políticas e contratos de cada parceiro. Da mesma forma, a garantia sobre a instalação é de responsabilidade direta do parceiro, seguindo as condições estabelecidas no momento da contratação.`,
  },
  {
    pergunta: 'Qual a vida útil dos equipamentos?',
    resposta: `Os módulos possuem entre 25 a 30 anos de vida útil, enquanto os inversores de 13 a 15 anos.`,
  },
  {
    pergunta: 'Vou ter que trocar o inversor em algum momento?',
    resposta: `Sim, porém será em aproximadamente 15 anos, onde a tecnologia estará mais evoluída e os equipamentos mais eficientes.`,
  },
  // {
  //   pergunta:
  //     'Quais são os termos e condições aplicáveis aos contratos de financiamento de painéis solares?',
  //   resposta: `Os termos e condições específicos para o financiamento fotovoltaico estão disponíveis para download <a href="pdf/termos-e-condicoes-fotovoltaico.pdf" target="_blank">aqui</a>.`,
  // },
  {
    pergunta:
      'Posso gerar energia em um único endereço para ser consumido em lugares diferentes? Como no meu estabelecimento ou em outra residência?',
    resposta: `Sim, é possível. É preciso analisar caso a caso, e os especialistas do parceiro irão te orientar caso queira gerar energia para dois ou mais endereços em um único local.`,
  },
];
